function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

var configureStore = function configureStore(_ref) {
    var reducer = _ref.reducer,
        initialState = _ref.initialState,
        _ref$middleware = _ref.middleware,
        middleware = _ref$middleware === undefined ? [thunk] : _ref$middleware;
    return createStore(reducer, initialState, applyMiddleware.apply(undefined, _toConsumableArray(middleware)));
};

export default configureStore;